/**
 * Created by Jonas Wålekvist on 2018-05-31.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    ISymbolStates,
    StateReelSymbol,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {PixiesVsPiratesGameConfig} from "../PixiesVsPiratesGameConfig";
import {PPReelSymbolName} from "./PPReelSymbolName";

export interface IPixiesVsPiratesSymbolStates extends ISymbolStates {
    noWin:ISymbolStateConfig;
    nudge:ISymbolStateConfig;
    attention:ISymbolStateConfig;
    idle:ISymbolStateConfig;
    individualwin:ISymbolStateConfig;
    expand:ISymbolStateConfig;
    normalExpand:ISymbolStateConfig;
    bounce:ISymbolStateConfig;
}

export class PixiesVsPiratesReelSymbol extends StateReelSymbol {

    protected _symMask:PIXI.Graphics | null;
    protected _winGlow:PIXI.Sprite | null;

    protected _displayScale:number = 1;

    protected _bounceSprite:PIXI.Sprite | null;
    protected _bounceSpine:PIXI.spine.Spine | null;

    public set symHeight(value:number) {
        if(value === this._symHeight) {
            return;
        }
        this._symHeight = value;
        for(let stateName in this._stateAnimations) {
            const state = this._stateAnimations[stateName];
            if(state != null) {
                StateReelSymbol.setStackedSymbolStateAnchor(this, state);
            }
        }

        this.updateHeightDisplay();
    }

    public get symHeight():number {
        if(this._symHeight == null) {
            return GameConfig.instance.SYMBOL_HEIGHT;
        }

        return this._symHeight;
    }

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig, size?:ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    protected initAnimations():void {
        this._winGlow = new PIXI.Sprite(GameResources.getTextures("winGlow")[0]);
        this._winGlow.anchor.set(0.5, 0.5);
        this._winGlow.alpha = 0;
        this._winGlow.blendMode = PIXI.BLEND_MODES.ADD;
        this._winGlow.name = "bounce";
        this.addChild(this._winGlow);

        if(!this._bounceSprite && [PPReelSymbolName.X, ReelSymbolName.SCATTER, ReelSymbolName.WILD, "E"].indexOf(this.symName) < 0) {
            this.createBounceSpine();
        }

        //this.tmpDebugHandler();
    }

    private tmpDebugHandler():void {
        const ref = this;


        document.addEventListener("keydown", function(e) {
            var keyCode = e.keyCode;
            //console.log("KeyCode: " + keyCode);

            switch(keyCode) {
                case 48:
                    break; // 0
                case 57:
                    ref.playBounce();
                    break; // 9
            }
        }, false);
    }

    protected addNewStateAnimation(timeline:gsap.TimelineLite, newState:SymbolStateTransition, stateAnimation:TimelineSprite, delay:number):void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if(this.currentState && this.currentState.keyword === "spin") {
        } else if(!this._bounceSprite) {
            if([PPReelSymbolName.X, ReelSymbolName.SCATTER, ReelSymbolName.WILD, "E"].indexOf(this.symName) < 0) {
                if(this.symName.indexOf("W") < 0) {
                    this.createBounceSpine();
                }
            }
        }

        if(this._winGlow) {
            if(newState.state.keyword === GameConfig.instance.SYMBOL_STATES.win.keyword) {
                timeline.add([
                    TweenLite.fromTo(this._winGlow, 0.07, {alpha : 0}, {alpha : 1}),
                    TweenLite.fromTo(this._winGlow.scale, 0.07, {x : 0.1, y : 0.1}, {x : 1, y : 1})
                ], delay);
            } else if(newState.state.keyword === PixiesVsPiratesGameConfig.instance.SYMBOL_STATES.individualwin.keyword) {
                const alphaTimeline:TimelineLite = new TimelineLite();
                alphaTimeline.fromTo(this._winGlow, 0.3, {alpha : 0.6}, {alpha : 1})
                    .to(this._winGlow, 0.3, {})
                    .to(this._winGlow, 0.2, {alpha : 0.6});
                const scaleTimeline:TimelineLite = new TimelineLite();
                scaleTimeline.fromTo(this._winGlow.scale, 0.3, {x : 0.75, y : 0.75}, {x : 1, y : 1})
                    .to(this._winGlow.scale, 0.3, {})
                    .to(this._winGlow.scale, 0.2, {x : 0.75, y : 0.75});
                timeline.add([
                    alphaTimeline,
                    scaleTimeline
                ], delay);
            } else {
                timeline.add(TweenLite.to(this._winGlow, 0.05, {alpha : 0}), delay);
            }
        }

        if(this._bounceSprite && this._bounceSpine && newState.state.keyword === PixiesVsPiratesGameConfig.instance.SYMBOL_STATES.bounce.keyword) {
            timeline.add(() => {
                if(this._bounceSprite) {
                    this._bounceSprite.visible = true;
                }
                this.playBounce();
            }, delay);
        } else if(newState.state.keyword === PixiesVsPiratesGameConfig.instance.SYMBOL_STATES.bounce.keyword) {
            if(this._bounceSpine) {
                this._bounceSpine.destroy(true);
                this._bounceSpine = null;
            }

            if(this._bounceSprite) {
                this._bounceSprite = null;
            }
        }

        if(newState.state.keyword === GameConfig.instance.SYMBOL_STATES.noWin!.keyword && this._bounceSprite && this._bounceSpine) {
            this._bounceSprite.visible = false;
            this._bounceSpine.visible = false;
        }

    }

    public playBounce():void {
        if(this._bounceSprite && this._bounceSpine) {
            this.playBounceAnimation();
        }
    }

    protected createBounceSpine(track:number = 0):void {
        if(!this._bounceSprite && !this._bounceSpine) {
            this._bounceSprite = new PIXI.Sprite();
            this._bounceSprite.name = "bounce";

            this._bounceSpine = new PIXI.spine.Spine(GameResources.getSpineAsset(this.symName + "_bounce"));

            this._bounceSprite.addChild(this._bounceSpine);
            this._bounceSprite.anchor.set(0.5, 0.5);
            this._bounceSprite.visible = false;

            this._bounceSpine.skeleton.setToSetupPose();
            this._bounceSpine.state.tracks = [];

            this.addChild(this._bounceSprite);
        }
    }

    protected playBounceAnimation(onEnd:(trackEntry:PIXI.spine.core.TrackEntry) => void = () => {}, track:number = 0, animationName:string = "animation", loop:boolean = false, timeScale:number = 1):void {
        if(this._bounceSpine && this._bounceSprite) {

            this._bounceSprite.visible = true;
            this._bounceSpine.visible = true;

            if(this._bounceSpine.skeleton && this._bounceSpine.state) {
                this._bounceSpine.skeleton.setToSetupPose();
                this._bounceSpine.state.tracks = [];
            }

            let noBounceChildren:PIXI.Sprite [] = [];
            (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
                if(sprite!.name !== "bounce" && sprite!.name !== "frameAndBg" && sprite!.name !== "mask") {
                    sprite!.visible = false;
                    noBounceChildren.push(sprite);
                }
            });

            (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
                if(sprite!.name === "bounce") {
                    this.addChild(sprite);
                }
            });

            if(this._bounceSpine.state) {
                this._bounceSpine.state.timeScale = timeScale;
                this._bounceSpine.state.setAnimation(track, animationName, loop);

                let end = (entry:PIXI.spine.core.TrackEntry) => {
                    onEnd(entry);
                    if(this._bounceSpine && this._bounceSpine.state) {
                        this._bounceSpine.state.removeListener(listener);

                        noBounceChildren.forEach((sprite) => {
                            sprite.visible = true;
                        });

                        (<PIXI.Sprite[]>this.children).forEach((sprite:PIXI.Sprite) => {
                            if(sprite!.name !== "bounce" && sprite!.name !== "frameAndBg" && sprite!.name !== "mask") {
                                sprite!.visible = false;
                            }
                        });

                        //this._bounceSpine = null;
                        //this._bounceSprite = null;
                    }
                };
                let listener = {complete : end};

                this._bounceSpine.state.addListener({
                    //event: function(entry, event) { console.log('event fired '+event.data+' at track' + entry.trackIndex) },
                    complete : (entry) => end(entry)
                    //start: function(entry) { console.log('animation is set at '+entry.trackIndex) },
                    //end: function(entry) { console.log('animation was ended at '+entry.trackIndex) }
                });
            }
        }
    }

    protected reset(remove:boolean):void {
        if(this._winGlow) {
            this.removeChild(this._winGlow);
            this._winGlow = null;
        }
        this.resetSymMask();

        if(this._bounceSpine) {
            this._bounceSpine.destroy(true);
            this._bounceSpine = null;
        }

        if(this._bounceSprite) {
            this._bounceSprite = null;
        }

        super.reset(remove);
    }

    protected resetSymMask():void {
        if(this._symMask) {
            this.removeChild(this._symMask!);
            this._symMask = null;
        }
    }

    protected updateHeightDisplay():void {
        this._displayScale = MathHelper.roundToDecimals(this.symHeight / GameConfig.instance.SYMBOL_HEIGHT, 2);
        this.resetSymMask();
        this.drawSymMask();
    }

    protected drawSymMask():boolean {
        if(this.symHeight < GameConfig.instance.SYMBOL_HEIGHT) {
            this._symMask = new PIXI.Graphics();
            this._symMask.beginFill(0xFF0000, 1);
            this._symMask.drawRect(-GameConfig.instance.SYMBOL_WIDTH / 2, -this.symHeight / 2, GameConfig.instance.SYMBOL_WIDTH, this.symHeight);
            this.addChild(this._symMask);
            this.mask = this._symMask;
            return true;
        }
        return false;
    }
}